export default function handleErrorWithToast(err) {
  let text = err.message
  try {
    text =
      err.errors &&
      Object.keys(err.erros)
        .map((key) => err.errors[key][0])
        .join(', ')
  } catch (e) {
    //
  }

  this.$toast({ type: 'error', title: err.message || '', text })
  throw err
}
